{
  "maximum": "Največji",
  "minimum": "Najmanj"
}
